// removed by extract-text-webpack-plugin
module.exports = {"root":"Header__root___3Zj8k","logo":"Header__logo___BbmRY","strapline":"Header__strapline___3Kzmu","social":"Header__social___149Ez"};


//////////////////
// WEBPACK FOOTER
// ./app/views/Header/Header.css
// module id = 108
// module chunks = 0